import { TimeRange } from "@/stores";
import { SoftDateTimePicker } from "@soft-db/ui";
import { useVModel } from "@vueuse/core";
import { DateTime } from "luxon";
import { computed, defineComponent, PropType, ref, watch } from "vue";
import AppDialog from "./AppDialog.vue";

export default defineComponent({
	name: "AppTimeRangeDialog",
	components: {
		AppDialog,
	},
	props: {
		modelValue: { type: Object as PropType<TimeRange> },
		dialog: Boolean,
	},
	setup(props, { emit }) {
		const { t } = useI18n();

		const vModel = useVModel(props, "modelValue");
		const dialog = useVModel(props, "dialog");

		const now = DateTime.fromObject({}, { zone: props.modelValue?.start.zone });

		const range = ref<TimeRange>(
			vModel.value || {
				start: DateTime.now(),
				end: DateTime.now(),
			}
		);
		watch(
			vModel,
			() => {
				if (!vModel.value) return;
				range.value = { ...vModel.value };
			},
			{ immediate: true }
		);

		const startTime = computed({
			get: () => range.value.start,
			set: (start) => (range.value.start = start),
		});

		const endTime = computed({
			get: () => range.value.end,
			set: (end) => (range.value.end = end),
		});

		const saveTimeRange = () => {
			vModel.value = { ...range.value };
			closeDialog();
		};

		const closeDialog = () => {
			emit("close");
		};

		return () => (
			<AppDialog
				class="md:min-w-90! md:w-[30vw] md:max-w-lg"
				modelValue={dialog.value}
				actionText={t("common.save")}
				persistent
				onClick:action={saveTimeRange}
				onClose={closeDialog}
			>
				{{
					title: () => t("dashboard.selectTimeRange"),
					content: () => (
						<div class="flex w-full flex-col">
							<SoftDateTimePicker
								v-model={startTime.value}
								max={endTime.value}
								label={t("dashboard.from")}
							/>
							<SoftDateTimePicker
								v-model={endTime.value}
								min={startTime.value}
								max={now}
								label={t("dashboard.to")}
							/>
						</div>
					),
				}}
			</AppDialog>
		);
	},
});
